import React from 'react';
import Link from 'gatsby-link';
import {injectIntl, intlShape} from 'react-intl';

import Is from './flags/is';
import En from './flags/us';

const propTypes = {
  intl: intlShape.isRequired,
};

const SelectLanguage = (props) => {

  const size = props.size;

  const getFlag = (langKey) => {
    switch(langKey) {
      case 'en': return <En size={size}/>;
      case 'is': return <Is size={size}/>;
      default: return null;
    }
  }

  const setHoverText = (langKey) => {
    switch(langKey) {
      case 'en': return "Switch to English";
      case 'is': return "Switch to Icelandic";
      default: return null;
    }
  }

  const link = props.langs.map (lang => {
    if (lang.langKey != props.intl.locale) return (
      <Link to={lang.link} key={lang.langKey} className="flag" title={setHoverText(lang.langKey)}> 
          {getFlag(lang.langKey)}
      </Link>
    )
  })

  return (
    <div>
      {link}
    </div>
  )
}

export default injectIntl(SelectLanguage);



// WEBPACK FOOTER //
// ./src/components/Header/SelectLanguage.js